module.exports = __webpack_public_path__ + "res/ic_portrait.a8ff553c7d205e742ba1bd3b2b4ad4bc.png";